import React, { useEffect, useState } from "react";
import { Toast,ToastContainer } from "react-bootstrap";

function Footer(props) {
    
    const [showToast, setShowToast] = useState(() => props.showToast === true);
    const [toastMsg, setToastMsg] = useState('Operación completada con éxito');
    const [delay, setDelay] = useState(3000);

    useEffect(() => {
        if (props.showToast !== undefined) {
            setShowToast(props.showToast === true);
        }
    },[props.showToast]);

    useEffect(() => {
        if (props.delay !== undefined && props.delay !== null) {
            setDelay(props.delay);
        }
    }, [props.delay]);

    useEffect(() => {
        if (props.message) {
            setToastMsg(props.message);
            setTimeout(() => { setShowToast(true) },800);
        }
    },[props.message]);

    useEffect(() => {
        if (props.showToast === false) {
            localStorage.removeItem('toastmsg');
            localStorage.removeItem('showtoast');
            localStorage.removeItem('toastdelay');
            return;
        }
        const msg = localStorage.getItem('toastmsg');
        const showFlag = localStorage.getItem('showtoast');
        if (msg) {
            setToastMsg(msg);
            setTimeout(() => { setShowToast(true); }, 800);
            localStorage.removeItem('toastmsg');
        } else if (showFlag) {
            setToastMsg('Operación completada con éxito');
            setTimeout(() => { setShowToast(true); }, 800);
        }
        localStorage.removeItem('showtoast');
        const toastDelay = localStorage.getItem('toastdelay');
        if (toastDelay) {
            setDelay(Number(toastDelay) || 3000);
            localStorage.removeItem('toastdelay');
        }
    }, [props.showToast]);

    return (
            <>
            <footer className="main-footer">
                <strong>Copyright <a href="#">AURORA SOLUTIONS S.A.S</a>.</strong> Todos los derechos reservados
            </footer>
            <ToastContainer className="toast-exito">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={delay} autohide>
                    <Toast.Body><i className="fas fa-check-circle"></i><p>{toastMsg}</p></Toast.Body>
                </Toast>
            </ToastContainer>
            </>
            );
}

export default Footer;